import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { SimpleCloseIcon } from '../../../../../assets/Logos/Icons'
import DatePickers from '../../../../ManagePrescriptionComponents/DatePicket/DatePicker'
import styles from './index.module.scss'

function DatePickerModal({ showModal, hidemodal, title, onSubmit }) {
    return (
        <Modal
            closeButton
            show={showModal}
            onHide={hidemodal}
            className={styles.date_picker_modal_align}
            backdrop="static"

        >
            <Modal.Body>
                <div className={styles.modalContent}>

                    <div className={styles.closeBar} onClick={hidemodal}>
                        <SimpleCloseIcon />
                    </div>
                    <div className={styles.title}>{title}</div>


                    <div className={styles.form_item}>
                       <DatePickers style={{width:"100% !important"}} />
                    </div>


                </div>
            </Modal.Body>
            <Button
                className={styles.patient_consent_accept_button}
                onClick={() => { }}
            >
                Save
            </Button>

        </Modal>
    )
}

export default DatePickerModal